import React, { useEffect } from 'react';
import styled from 'styled-components';

import errorSoundSrc from 'assets/sounds/error.wav';
import error from 'assets/windowsIcons/897(32x32).png';

function lineBreak(str) {
  return str.split('\n').map((s, i) => (
    <p key={i} className="error__message">
      {s}
    </p>
  ));
}

function Error({
  onClose,
  message = "Something's wrong!",
  backgroundColor,
  background,
  headline,
  bannerSrc,
  bannerHref,
  bannerCtaText = 'Apply to Sessions',
}) {
  useEffect(() => {
    try {
      new Audio(errorSoundSrc).play();
    } catch (e) {
      console.log(e);
    }
  }, []);

  if (bannerSrc) {
    return (
      <BannerWrap>
        {bannerHref && (
          <a
            href={bannerHref}
            target="_blank"
            rel="noreferrer"
            className="error__banner__cta"
          >
            {bannerCtaText}
          </a>
        )}
        <img src={bannerSrc} alt="" className="error__banner" />
      </BannerWrap>
    );
  }

  return (
    <Div
      $bg={background || backgroundColor}
      $useDefaultBg={!background && !backgroundColor}
    >
      <div className="error__top">
        <img src={error} alt="error" className="error__img" />
        <div className="error__messages">
          {headline && <p className="error__headline">{headline}</p>}
          {lineBreak(message)}
        </div>
      </div>
      <div className="error__bottom">
        <div onClick={onClose} className="error__button">
          <span className="error__confirm">OK</span>
        </div>
      </div>
    </Div>
  );
}

const BannerWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  position: relative;
  .error__banner__cta {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    padding: 4px 16px 4px 12px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    background: #000;
    border: 1px solid #555;
    text-decoration: none;
    white-space: nowrap;
    box-shadow: 1px 1px 0 #555;
    transition: background 120ms ease-out, transform 100ms ease-out;
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: #222;
      }
    }
    &:active {
      transform: translateY(-50%) scale(0.97);
    }
  }
  .error__banner {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Div = styled.div`
  background: ${({ $bg, $useDefaultBg }) =>
    $useDefaultBg ? '#f5f5f5' : $bg || '#f5f5f5'};
  width: 100%;
  height: 100%;
  font-size: 11px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  .error__top {
    display: flex;
    flex: 1;
  }
  .error__img {
    width: 30px;
    height: 30px;
  }
  .error__messages {
    padding: 2px 20px 12px;
  }
  .error__headline {
    font-size: 13px;
    font-weight: bold;
    margin: 0 0 6px 0;
    line-height: 1.3;
  }
  .error__message {
    line-height: 16px;
  }
  .error__bottom {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  .error__button {
    width: 80px;
    height: 22px;
    display: flex;
    border: 1px solid black;
    justify-content: center;
    align-items: center;
    box-shadow: inset -1px -1px 1px black;
    &:hover:active {
      box-shadow: inset 1px 1px 1px black;
      & > * {
        transform: translate(1px, 1px);
      }
    }
  }
  .error__confirm {
    line-height: 11px;
  }
`;

export default Error;
